export const saveToStorage = (storageKey: string, value: unknown, storage: Storage) => {
    try {
        storage.setItem(storageKey, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
};
